// TODO: Remove this wrapper once timeout is added to HTTP clients
// Track: Add timeout to healthieClient and patientAppApiRequest
export const withTimeout = <T>(
  promise: Promise<T>,
  operation: string,
  timeoutMs: number = 30000,
): Promise<T> => {
  return Promise.race([
    promise,
    new Promise<T>((_, reject) =>
      setTimeout(
        () => reject(new Error(`${operation} timeout after ${timeoutMs}ms`)),
        timeoutMs,
      ),
    ),
  ]);
};
